import { getUserPortalUrl } from '@/utils/path-utils';

interface SamlInitResponse {
  auth_id: string;
  redirect_url: string;
  expires_in: number;
}

/**
 * Initiate SAML auth flow via user-portal-api.
 * Called from web-login on tenant subdomains ({tenant}.{domain}) to start
 * the SAML flow directly, without redirecting to user-portal first.
 *
 * Uses same-origin relative URL — Traefik routes /user-portal-api/*
 * on tenant subdomains to the user-portal-api backend.
 */
export async function initiateSamlAuth(): Promise<SamlInitResponse> {
  const response = await fetch('/user-portal-api/saml/init', {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`SAML init failed: ${response.status}`);
  }

  return response.json();
}

/**
 * Initiate SAML auth and redirect to the IdP, or fall back to user-portal
 * if SAML init fails (e.g., tenant without SAML configured).
 *
 * Used by both main.tsx (pre-React tenant root) and ValidatingPage (no valid auth session).
 */
export async function initiateSamlOrFallback(
  fallbackPath = '/'
): Promise<void> {
  let redirectUrl: string;

  try {
    const response = await initiateSamlAuth();
    redirectUrl = response.redirect_url;
  } catch (error) {
    console.error('SAML init failed, falling back to user-portal', error);
    redirectUrl = getUserPortalUrl(fallbackPath);
  }

  window.location.replace(redirectUrl);
}
